import { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const AllergiesFreeType = ({
  patientDBdata,
  patientID,
  setPatientDBdata,
  noteActualId,
}) => {
  const [allergyIds, setAllergyIds] = useState([])
  const [allergies, setAllergies] = useState([])
  const [tempAllergyHtml, setTempAllergyHtml] = useState('')

  useEffect(() => {
    const metadataIds =
      patientDBdata?.currentNote?.data?.metadata?.allergiesIds ?? []

    setAllergyIds(Array.isArray(metadataIds) ? metadataIds : [])
  }, [patientDBdata, patientID])

  useEffect(() => {
    if (!allergyIds.length) {
      setAllergies([])
      return
    }

    const matched =
      patientDBdata?.patientAllergy
        ?.filter((item) => allergyIds.includes(item.id))
        .map((item) => ({
          ...item,
          data:
            typeof item.data === 'string'
              ? JSON.parse(item.data)
              : item.data,
        })) || []

    setAllergies(matched)
  }, [allergyIds, patientDBdata])

  // useEffect(() => {
  //   if (!allergies.length) return

  //   const generatedHtml = `
  //     <div>
  //       ${allergies
  //         .map(
  //           (item) => `
  //         <div style=""><strong>Allergen: ${item.data?.allergen || '-'}</strong> Severity: ${item.data?.severity || '-'} Reaction: ${item.data?.reaction || '-'}
  //         </div>
  //       `
  //         )
  //         .join('')}
  //     </div>
  //   `

  //   const savedFreeType =
  //     patientDBdata?.currentNote?.data?.freeTypesEverything
  //       ?.allergiesFreetype

  //   setTempAllergyHtml(savedFreeType || generatedHtml)
  // }, [allergies, patientDBdata])

  useEffect(() => {
  if (!allergies.length) return

  const generatedHtml = `
    <div>
      ${allergies
        .map(
          (item) => `
        <div>
          <strong>Allergen:</strong> ${item.data?.allergen || '-'} |
          <strong> Severity:</strong> ${item.data?.severity || '-'} |
          <strong> Reaction:</strong> ${item.data?.reaction || '-'}
        </div>
      `
        )
        .join('')}
    </div>
  `

  const savedFreeType =
    patientDBdata?.currentNote?.data?.freeTypesEverything
      ?.allergiesFreetype

  const initialHtml = savedFreeType || generatedHtml
  setTempAllergyHtml(initialHtml)

  // 👇 persist initial html if not already saved
  if (!savedFreeType) {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            allergiesFreetype: initialHtml,
          },
        },
      },
    }))
  }
}, [allergies])


  const handleBlur = () => {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            allergiesFreetype: tempAllergyHtml,
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              allergiesFreetype: tempAllergyHtml,
            },
          }),
        }
      }),
    }))
  }

  if (!allergyIds.length) return null

  return (
    <div className="d-flex">
      <div style={{ width: '30%' }}>Allergies</div>

      <div className="w-100">
        <Editor
          value={tempAllergyHtml}
          onChange={(e) => setTempAllergyHtml(e.target.value)}
          onBlur={handleBlur}
          containerProps={{
            style: {
              width: '100%',
              background: '#2D2D2D',
              color: 'white',
              border: 0,
              height:"100%",
              minHeight:"unset"
            },
          }}
        >
          <Toolbar hidden />
        </Editor>
      </div>
    </div>
  )
}

export default AllergiesFreeType
